import { Setting } from '@src/__generated__/types';
import React from 'react';

export function getSettingContextDefaultValue(): Setting {
    return {
        enableSearch: false,
        enableContentTranslation: false,
        enableAI: false,
        hiddenNodeActions: null,
        nodeActionsPlacement: null,
        cgtSettings: {
            coolsalesExporter: {
                couch: {
                    dbUri: '',
                    dbName: '',
                },
            },
            exporter: {
                couch: {
                    dbUri: '',
                    dbName: '',
                },
                sql: {
                    host: '',
                    user: '',
                    password: '',
                    database: '',
                },
            },
            pricelistCatNodeCode: '',
            listiniPerZMABCode: '',
            manodoperaSupplierId: '',
            useDynamicRules: false,
            skipCertificate: true,
            skipPublish: true,
            skipExport: true,
            skipStatus: true,
            skipHinto: true,
            forceCertificateButtonActive: false,
            showNodeStatuses: false,
            prototypeSetting: {
                prototypeHierarchyId: '',
                objectSchemaCode: '',
                modelCode: '',
                glCodes: [],
                certificationStatuses: {
                    certified: '',
                    draft: '',
                    certifiedDraft: '',
                    error: '',
                    certifiedError: '',
                    inCertification: '',
                    certifiedInCertification: '',
                    certifiedPublished: '',
                },
                priceCodes: {
                    dn: {
                        key: '',
                    },
                    dnWithDelta: {
                        key: '',
                    },
                    dn_cash_d: {
                        key: '',
                    },
                    tpa: {
                        key: '',
                    },
                    gp: {
                        key: '',
                    },
                    list_price: {
                        key: '',
                    },
                    lc: {
                        key: '',
                    },
                    gl_list_price: {
                        key: '',
                    },
                    gl_tpa: {
                        key: '',
                    },
                    dealer_gp: {
                        key: '',
                    },
                    dealer_ms: {
                        key: '',
                    },
                    dealer_price: {
                        key: '',
                    },
                    forced_gp: {
                        key: '',
                    },
                    forced_vn: {
                        key: '',
                    },
                    forced_dealer_gp: {
                        key: '',
                    },
                    forced_dealer_price: {
                        key: '',
                    },
                    extra_discount: {
                        key: '',
                    },
                    forced_tpa: {
                        key: '',
                    },
                    gp_ms: {
                        key: '',
                    },
                    gp_tpa: {
                        key: '',
                    },
                    markup: {
                        key: '',
                    },
                    mo: {
                        key: '',
                    },
                    ms: {
                        key: '',
                    },
                    standard_price_delta: {
                        key: '',
                    },
                    transport_costs: {
                        key: '',
                    },
                },
            },
            hierarchies: {
                cGTModelHierarchyId: '',
                glHierarchyId: '',
                priceListHierarchyId: '',
                supplierHierarchyId: '',
                cGTModelUsatoCompetitorHierarchyId: '',
                glGenericHierarchyId: '',
                attrezzatureFuoriListinoHierarchyId: '',
                glUsatoCompetitorHierarchyId: '',
                glExFlottaHierarchyId: '',
                mediaHierarchyId: '',
                sapProductHierarchyId: '',
                sapProductCompetitorHierarchyId: '',
                marcheHierarchyId: '',
                shortListsHierarchyId: '',
                longListsHierarchyId: '',
                commercialFamilyHierarchyId: '',
                shortListFamilyHierarchyId: '',
                sezioniSchedeHierarchyId: '',
                linkedGlsCompatibilityRulesHierarchyId: '',
                characteristicsCompatibilityRulesHierarchyId: '',
                usagesCompatibilityRulesHierarchyId: '',
                prototypeCompatibilitiesHierarchyId: '',
                shortListFamiliesExtraCharacteristicsHierarchyId: '',
                systemSubSystemHierarchyId: '',
                warrantySupplierHierarchyId: '',
                warrantyCgtHierarchyId: '',
                digitalServiceHierarchyId: '',
                serviceModuleHierarchyId: '',
                serviceContractHierarchyId: '',
                serviceModuleKmListHierarchyId: '',
                serviceModuleKitListHierarchyId: '',
                serviceModuleAMAListHierarchyId: '',
                productWarrantyHierarchyId: '',
                applicationCodeHierarchyId: '',
                cadenzaInterventoHierarchyId: '',
                mmDispoHierarchyId: '',
            },
            objectSchemas: {
                shortListFamiliesExtraCharacteristicsObjectSchemaId: '',
                longListsHierarchyObjectSchemaId: '',
                sapProductHierarchyObjectSchemaId: '',
                glHierarchyObjectSchemaId: '',
                cgtModelHierarchyObjectSchemaId: '',
                prototypeHierarchyObjectSchemaId: '',
            },
            fields: {
                nodeTypeField: {
                    contentTypeCode: '',
                    defaultValue: '',
                },
                orderTypeField: {
                    contentTypeCode: '',
                },
                lineaSapField: {
                    contentTypeCode: '',
                },
                marcaField: {
                    contentTypeCode: '',
                },
                sapProductHierarchyField: {
                    contentTypeCode: '',
                },
                biasedField: {
                    contentTypeCode: '',
                },
                extraValueSupportField: {
                    contentTypeCode: '',
                },
                incentiveVolumeField: {
                    contentTypeCode: '',
                },
                supplierField: {
                    contentTypeCode: '',
                },
                descriptionField: {
                    contentTypeCode: '',
                },

                suffixField: {
                    contentTypeCode: '',
                },
                supplierNameField: {
                    contentTypeCode: '',
                },
                priceListField: {
                    contentTypeCode: '',
                },
                typeField: {
                    contentTypeCode: '',
                    defaultValue: '',
                },
                itemsField: {
                    contentTypeCode: '',
                },
                c1Field: {
                    contentTypeCode: '',
                },
                c2Field: {
                    contentTypeCode: '',
                },
                c3Field: {
                    contentTypeCode: '',
                },
                lcField: {
                    contentTypeCode: '',
                },
                baseProgramField: {
                    contentTypeCode: '',
                },
                svField: {
                    contentTypeCode: '',
                },
                cvaField: {
                    contentTypeCode: '',
                },
                conquestField: {
                    contentTypeCode: '',
                },
                dealerDiscountField: {
                    contentTypeCode: '',
                },
                certificationStatusField: {
                    contentTypeCode: '',
                },
                installedDealerNetField: {
                    contentTypeCode: '',
                },
                notInstalledDealerNetField: {
                    contentTypeCode: '',
                },
                cashDiscountField: {
                    contentTypeCode: '',
                },
                glBaseMachineField: {
                    contentTypeCode: '',
                },
                denominationField: {
                    contentTypeCode: '',
                },
                familyField: {
                    contentTypeCode: '',
                },
                modelCodeField: {
                    contentTypeCode: '',
                },
                selectionsField: {
                    contentTypeCode: '',
                },
                flagUseDN: {
                    contentTypeCode: '',
                },
                segmento: {
                    contentTypeCode: '',
                },
                marca: {
                    contentTypeCode: '',
                },
                tipo: {
                    contentTypeCode: '',
                },
                divisione: {
                    contentTypeCode: '',
                },
            },
            groups: {
                pricingGroup: {
                    contentTypeGroupCode: '',
                },
                catSupportGroup: {
                    contentTypeGroupCode: '',
                },
                cgtSupportGroup: {
                    contentTypeGroupCode: '',
                },
                sapCharacteristicsGroup: {
                    contentTypeGroupCode: '',
                },
            },
            paths: {
                accessories: '',
                baseMachine: '',
                priceListValue: '',
                primaryPriceListValue: '',
                secondaryPriceListValue: '',
                itemsValue: '',
                sapProductHierarchyValue: '',
            },
            discountMPRoles: [],
        },
        customPages: null,
        defaultPageUri: null,
        hierarchiesPageRoles: null,
        favoriteRoles: null,
        appBar: null,
        createHierarchyRoles: null,
        channels: null,
        jobList: [],
        globalSearch: null,
    };
}

export const SettingsContext = React.createContext<Setting>(getSettingContextDefaultValue());
